import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styleable from 'react-styleable';
import { injectIntl, intlShape } from 'react-intl';
import Loader from 'halogen/PulseLoader';

import css from './index.scss';
import messages from './messages';

import {
    getCountryCode,
    getLocale
} from '../../helpers/utils';
import { privacySettingSaveRequestEnum } from '../../helpers/enums';

import NameSettings from './sub-components/name-settings';
import LanguageSettings from './sub-components/language-settings';
import AcademicYearSettings from './sub-components/academic-year-settings';
import PrivacySettingsFooter from './sub-components/privacy-settings-footer';

/**
 * ENUMS
 */
const {
    SCHOOL_LOCALE,
    SCHOOL_COUNTRY,
    NAME_FORMAT
} = privacySettingSaveRequestEnum;

/**
 * PRIVACY SETTINGS
 * ----------------------
 * Manages user name, language and academic year preferences/settings
 */
class PrivacySettings extends Component {
    constructor(props) {
        super(props);
        this.defaultValue = -1;
        this.state = {
            isOptionsUpdated: false,
            saveRequest: [
                {
                    type: SCHOOL_COUNTRY,
                    value: this.defaultValue
                },
                {
                    type: SCHOOL_LOCALE,
                    value: this.defaultValue
                },
                {
                    type: NAME_FORMAT,
                    value: this.defaultValue
                }
            ]
        };
    }

    getDefaultValue = (optionObj, type) => {
        const { saveRequest } = this.state;
        const findType = saveRequest.find(s => s.type === type).value;
        if (findType !== this.defaultValue) return findType;

        switch (type) {
        case NAME_FORMAT:
            return optionObj.preferredValue ? optionObj.preferredValue : optionObj.availableOptions.find(opt => opt.isDefault).value;
        case SCHOOL_COUNTRY:
            return optionObj.preferredValue ? optionObj.preferredValue : getCountryCode();
        case SCHOOL_LOCALE:
            return optionObj.preferredValue ? optionObj.preferredValue : getLocale();
        default:
            return this.defaultValue;
        }
    }

    onOptionSelection = (element) => {
        const id = element.target.id;
        this.setState(prevState => ({
            isOptionsUpdated: true,
            saveRequest: prevState.saveRequest.map(
                s => (s.type === NAME_FORMAT ? { ...s, value: id } : { ...s })
            )
        }));
    }

    onDropdownChange = (field, value) => {
        this.setState(prevState => ({
            isOptionsUpdated: true,
            saveRequest: prevState.saveRequest.map(
                s => (s.type === field ? { ...s, value } : { ...s })
            )
        }));
    }

    render() {
        const {
            isSaveInProgress,
            intl,
            isDataLoaded,
            settingPreferences,
            handleOnSave
        } = this.props;
        const {
            isOptionsUpdated,
            saveRequest
        } = this.state;

        return isDataLoaded ? (
            <div className={css.privacySettings}>
                <div className={css.header}>
                    <div className={css.title}>{intl.formatMessage(messages.pageTitle)}</div>
                </div>
                <div className={css.settings}>
                    <NameSettings
                        getDefaultValue={this.getDefaultValue}
                        onSelectHandler={this.onOptionSelection}
                        preferences={settingPreferences.preferences}
                    />
                    <div className={css.seprator__horizontal} />
                    <LanguageSettings
                        getDefaultValue={this.getDefaultValue}
                        onSelectHandler={this.onDropdownChange}
                        preferences={settingPreferences.preferences}
                    />
                    <div className={css.seprator__horizontal} />
                    <AcademicYearSettings
                        academicYear={settingPreferences && settingPreferences.academicYear}
                    />
                </div>
                <PrivacySettingsFooter
                    handleOnSave={handleOnSave}
                    isOptionsUpdated={isOptionsUpdated}
                    isSaveInProgress={isSaveInProgress}
                    saveRequest={saveRequest}
                />
            </div>
        ) : (
            <div className={css.privacySettings}>
                <div className={css.loaderContainer}>
                    <Loader className={css.loader} />
                </div>
            </div>
        );
    }
}

PrivacySettings.propTypes = {
    intl: intlShape.isRequired,
    settingPreferences: PropTypes.shape({
        preferences: PropTypes.array,
        academicYear: PropTypes.shape({
            endDate: PropTypes.string,
            id: PropTypes.number,
            isSchoolLevel: PropTypes.bool,
            startDate: PropTypes.string,
            year: PropTypes.number
        })
    }),
    handleOnSave: PropTypes.func,
    isSaveInProgress: PropTypes.bool,
    isDataLoaded: PropTypes.bool
};

export default injectIntl(styleable(css)(PrivacySettings));



// WEBPACK FOOTER //
// ./app/components/privacy-settings/index.js